import axios from "axios";
import { getBrowserApiBaseUrl, isBrowserApiProxied } from "@/lib/browserBackend";

export const baseLLMApiUrl = getBrowserApiBaseUrl();

const api: any = axios.create({
  baseURL: baseLLMApiUrl,
  withCredentials: isBrowserApiProxied(),
});

const chatApiUrl = `${baseLLMApiUrl}/api`;

export const chatUnifiedEndpointApiUrl = `${chatApiUrl}/unified-endpoint`;
/** Teams AI Assist / meeting-notes chat (same host as unified chat). */
export const chatMeetingNotesChatApiUrl = `${chatApiUrl}/v1/meeting-notes/chat`;
export const fetchChatHistoryFromSession = (sessionId: any) =>
  `${chatApiUrl}/sessions/${sessionId}/history`;
export const getThreadHistoryUrl = (useremail: any) => `${chatApiUrl}/sessions`;

// Validate meetingId to prevent unsafe characters from affecting the request path.
// Allow only alphanumeric characters, hyphen and underscore, and enforce a reasonable length.
function validateMeetingId(meetingId: string): string {
  if (typeof meetingId !== "string") {
    throw new Error("Invalid meetingId");
  }
  const trimmed = meetingId.trim();
  // Exchange / Graph meeting IDs are often 150+ chars (e.g. AAMk…)
  if (trimmed.length === 0 || trimmed.length > 2048) {
    throw new Error("Invalid meetingId");
  }
  if (!/^[A-Za-z0-9_-]+$/.test(trimmed)) {
    throw new Error("Invalid meetingId");
  }
  return trimmed;
}

export const getMeetingChatHistoryUrl = (meetingId: string) => {
  const safeMeetingId = validateMeetingId(meetingId);
  return `${chatApiUrl}/meeting-notes/chat/meeting/${safeMeetingId}/history`;
};
export const collectionChatApiUrl = `${chatApiUrl}/v1/collections/chat`; // POST
export const employee360ApiUrl = `${chatApiUrl}/v1/employee-360`; // POST

export default api;
